/* eslint-disable no-nested-ternary */
import React from 'react'
import { IcoMoon, Box, KeyboardArrowRightIcon } from '@usap/uicomponents'
import { TextWithStyle, BreadCrumbBox } from './style/TempBreadCrumb.css'

export default function TempBreadcrumb({
  links = [],
  Link = () => "",
  exitReturnDetails,
  isScroll = true
}) {
  const length = links.length;
  if (length === 0) {
    return null
  }
  return (
    <Box width="1248px" margin={{vertical:"0px", horizontal:'auto'}}>
      <BreadCrumbBox
        id="breadCrumbList"
        as="ul"
        width="1248px"
        className={isScroll ? "breadCrumbListScrollable" : ''}
      >
        {links.map((item, index) => {
          let maxLength = length === index + 1;
          return (
            <Box
              id={(item.name || item.text).replace(/ /g, "")}
              key={item.name || item.text}
              as="li"
              direction="row"
              align="center"
              justify="center"
            >
              { maxLength ? (
                <TextWithStyle
                  textAlign="center"
                  color="dark-2"
                  weight={maxLength ? "bold" : "normal"}
                  noPointer={maxLength}
                  size="xsmall"
                >
                 {item.name || item.text}
                </TextWithStyle>
              ) : (
                <>
                  {item.text === "Order Details" || item.text === 'Returns' ? (
                    <TextWithStyle
                      textAlign="center"
                      color="dark-2"
                      weight={maxLength ? "bold" : "normal"}
                      noPointer={maxLength}
                      size="xsmall"
                      onClick={exitReturnDetails}
                      itemProp="name"
                      content={item.name || item.text}
                      style={{ lineHeight: "23px" }}
                    >
                      {item.name || item.text}
                    </TextWithStyle>
                  ) : (
                    <Link
                      to={item.link || item.url || item.value}
                      style={{ lineHeight: '20px' }}
                    >
                      <TextWithStyle
                        textAlign="center"
                        color="dark-2"
                        weight={maxLength ? "bold" : "normal"}
                        noPointer={maxLength}
                        size="xsmall"
                        itemProp="name"
                        content={item.name || item.text}
                        style={{ lineHeight: "23px" }}
                      >
                       {item.name || item.text}
                      </TextWithStyle>
                    </Link>
                  )}
                </>
              )}

              {!maxLength && (
                <Box pad={{ horizontal: "xsmall" }}>
                  <IcoMoon
                    icon={KeyboardArrowRightIcon}
                    color="dark-2"
                    size="20px"
                  />
                </Box>
              )}
            </Box>
          );
        })}
      </BreadCrumbBox>
    </Box>
  );
}
